module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_24"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478522"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Five")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Pseudo Vacation")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("From the public observation deck on the top floor of the government offices in the Shinjuku District, The Seeker had an unobstructed three-hundred-and-sixty-degree view. No undeveloped land existed between where he stood and the next metropolis,")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("effectively")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("amalgamating Tokyo into the largest city in the world. He sat with a coffee and took in Mt. Fuji’s symmetry -- the perfect way to start the day. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("In the latter part of the morning, The Seeker strolled the ultra-expensive Ginza neighborhood, as well as the old Asakusa section of Tokyo.  Curiosity motivated him to explore the decadent Kabukicho red light district with a final respite at the sprawling Shinjuku National Park, an emerald retreat in the middle of the city. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Returning to his hotel via the Green Train’s circular route, The Seeker")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("was impressed with the number of solar panels that adorned many of the tiled")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("rooftops. While making a mental note to tell the Central Committee that they should encourage increased use of solar power, he was pleased how even this small observation would help promote his vision and therefore")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("weaken the Second-in-Command’s oil agenda.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Seeker believed that the next war between the")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("superpowers would be fought on the ecological front. Others in the Committee foolishly debated that it would be a confrontation")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("over the precious metals used in computers, or drinking water, or oil, and as a result they spent time arguing for the control of sea-lanes.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Instead, The Seeker chose to ignore these discussions and fight the war that would connect all scenarios. In the world to come, whoever had ecologically neutral energy had control of everything. He envisioned gigantic solar and wind farms, wave plants powering enormous desalination factories so that fresh water was no longer an issue while at the same time, making oil obsolete. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Like Sun Tzu said in ")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("The Art of War")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(", The Seeker’s Holy Bible, “In the practical art of war, the best thing is to take the enemy’s country whole and intact; to shatter and destroy it is not so good…")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("supreme excellence consists in breaking the enemy’s resistance without fighting.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Moral authority was what The Seeker wanted for his beloved China and green energy could do that. In the future, military might alone would not be enough. After all, the Union of Soviet Socialist Republic had had nearly unlimited force, but today")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("the Soviet State no longer existed. As soon as the Chinese leaders")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("perceived that the American strategy was to outspend the Soviets, not out bomb them, the Politburo had implemented a plan to push China towards a market economy. They had learned what the extinct Soviets had realized too late -- financial power was every bit as potent as any nuclear arsenal.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Moral authority could lead to influence and Sun Tzu grasped that influence is what an enlightened nation coveted. The Seeker understood that to devour the planet’s resources while entire continents")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("starved to death would only inflame the poor to rise up against the rich. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("For humanity, there was a fast approaching truth, either the rich could acknowledge the poor and have a relationship with them")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("through sharing and peaceful coexistence or live violently with the desperate")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("who believed that the rich had stolen everything. By using religious dogma to label the rich as devils, the poor would see them as the enemy and that would result in a never-ending war. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Only moral authority could defeat this manipulation and victory would be awarded to the country that had a supportive relationship with the impoverished. America had done this brilliantly after World War II, but since then, greed and the right wing’s failed experiment in an unrestrained free market had relegated them to what The Seeker called ‘Noise Makers.’ America still spoke, but no one was listening. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Seeker’s agenda and the strategy that drove the Second-in-Command into fits of rage was actually quite simple. In order for China to ascend once again to the status of Super Power, it must connect action on climate change to basic issues of jobs, resources, infrastructure, all the while closing the gap of inequality. There ")]), _c('span', {
    staticClass: "calibre36"
  }, [_vm._v("could be a better future for all,")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" but for that future to manifest, oil company domina")]), _c('span', {
    staticClass: "calibre38"
  }, [_vm._v("tion")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v(" must end. Any economic system that is focused solely on profit and ignores sustainability is doomed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre34"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The next day, The Seeker purchased tickets for a bus trip through the stunning Japanese Alps. While traveling, he read that tenacious rains had caused flooding in his homeland. The information coming from the Xinhau News Agency would naturally be heavily censored to protect the population from its severity. Why stress the citizens when it was so unnecessary? Western press bombarded their population twenty-four hours a day with horrific news in the hopes of high ratings and naturally, profit. Such manipulation succeeded in keeping the citizens in a constant state of anxiety and distracted from massive")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("corporate corruption. Censorship was so much more civilized.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("As the bus climbed up into the snow carpeted mountains, a passenger tried to start a conversation, but wanting to be alone with his thoughts, The Seeker pretended not to understand. The fewer people who knew he was fluent in Japanese, the better; it was of great benefit to surreptitiously eavesdrop. An advantage The Seeker had no inclination to give away for idle chitchat")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("and besides, he wanted ")]), _c('span', {
    staticClass: "calibre36"
  }, [_vm._v("time ")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("to contemplate. He recalled how the Second-in-Command had finagled the Committee into insisting that The Seeker take a well-earned vacation. Clearly not a coincidence, considering that the Party was currently holding important policy meetings. Thankfully, he had saved face by insisting that during his forced holiday he be assigned")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("a project. The Committee had actually acquiesced and gave him a task")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("dear to his heart. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Chairman had asked The Seeker to study how serious other countries were about Global Climate Change. Fearing the results of this assignment, The Second-in-Command changed tactics and argued that The Seeker looked tired and needed a complete break from Party duties, but fortunately the Politburo overruled his plea.")]), _c('span', {
    staticClass: "calibre33"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("After reaching its destination, the bus doors opened and The Seeker disembarked. Outside the rest stop, a few bored sales people offered soup and rice dumplings. Ignoring the temptation of sampling their fares, he stretched while admiring the mountains that towered over the parking lot and the wisps of clouds that raked across their majestic peaks. Fresh, high country air filled his lungs and he savored the sound of a distant waterfall. Walking into the little village of Hirayu Onsen, he looked every bit the tourist, and in most ways, he was, except for the other top-secret agenda")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The Chairman had integrated into his vacation. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("That was something far more sinister. He was to monitor society’s reaction to the impending death of one of the world’s most important citizens. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_25"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072e9d67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_008.vue
// module id = 84
// module chunks = 0